<template>
    <div class="container has-text-centered bng-narrow-container bng-login">
        <div class="columns">
            <div class="column">
                <div class="card">
                    <div class="card-content">
                        <p class="title">{{"components.pages.login.title" | translate}}</p>
                        <div v-if="passwordLoginAllowed && pinLoginAllowed" class="tabs is-centered">
                            <ul>
                                <li :class="{'is-active':tab=='pin'}" @click="tab='pin'">
                                    <a>{{"components.pages.login.pin.tab" | translate}}</a>
                                </li>
                                <li :class="{'is-active':tab=='login'}" @click="tab='login'">
                                    <a>{{"components.pages.login.login password.tab" | translate}}</a>
                                </li>
                            </ul>
                        </div>

                        <password-login v-if="passwordLoginAllowed && (tab=='login' || !pinLoginAllowed)" />
                        <pin-login v-if="pinLoginAllowed && (tab=='pin' || !passwordLoginAllowed)" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';

import PasswordLogin from './password-login.vue';
import PinLogin from './pin-login.vue';

export default {
    name: 'login',
    components: { PasswordLogin, PinLogin },
    data() {
        return {
            tab: 'pin',
            passwordLoginAllowed: false,
            pinLoginAllowed: false
        };
    },
    async created() {
        await Vue.state.client.ensure();
        let client = Vue.state.client.get();
        this.passwordLoginAllowed = client.login.loginTypes.indexOf('login') >= 0;
        this.pinLoginAllowed = client.login.loginTypes.indexOf('pin') >= 0;
    }
};
</script>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/login/login.vue